/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
==========================================================================================*/

import axios from "@/axios.js"
import global from "../store.js"
import l from "../../http/requests/serviceaideclients/index"
export default {
  addCompte({ commit }, item) {
    return new Promise((resolve, reject) => {
     // axios.post("/api/aideclients/comptes/", {item: item})
     l.addaideclient(global.state.AppActiveUser.username,item).then((response) => {
       console.log(response)
          commit('ADD_COMPTE', Object.assign(response.data ))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListComptes({ commit }) {
    return new Promise((resolve, reject) => {

      //axios.get("/api/aideclients/comptes")
       // l.listeaideclients('username').then((response) => {
        l.listeaideclients(global.state.AppActiveUser.id).then((response) => {
          commit('SET_COMPTES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // fetchEventLabels({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     axios.get("/api/apps/calendar/labels")
  //       .then((response) => {
  //         commit('SET_LABELS', response.data)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  updateComptes({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/aideclients/comptes/${item.id}`, {item: item})
        .then((response) => {
          commit('UPDATE_COMPTES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeComptes({ commit }, itemId) {
    return new Promise((resolve, reject) => {
     // axios.delete(`/api/aideclients/comptes/${itemId}`)
         //axios.delete(`/api/aideclients/comptes/${itemId}`)
         l.deleteaideclient(itemId)
        .then((response) => {
          commit('REMOVE_COMPTE', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/data-list/products")
        .then((response) => {
          commit('SET_PRODUCTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // eventDragged({ commit }, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`/api/apps/calendar/event/dragged/${payload.event.id}`, {payload: payload})
  //       .then((response) => {

  //         // Convert Date String to Date Object
  //         let event = response.data
  //         event.startDate = new Date(event.startDate)
  //         event.endDate = new Date(event.endDate)

  //         commit('UPDATE_EVENT', event)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchDataListCommmandesEncours({ commit }) {
    return new Promise((resolve, reject) => {

      //axios.get("/api/aideclients/comptes")
       // l.listeaideclients('username').then((response) => {
        l.listeCommandesEncours(global.state.AppActiveUser.customer_No).then((response) => {
          commit('SET_COMMANDESENCOURS', response.data.value)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
